import { render, staticRenderFns } from "./One.vue?vue&type=template&id=7b96ee2a&scoped=true"
var script = {}
import style0 from "./One.vue?vue&type=style&index=0&id=7b96ee2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96ee2a",
  null
  
)

export default component.exports